export const light = {
  title: 'light',
  colors: {
    primary: '#835afd',
    background: '#f8f8f8',
    text: '#29292e',
    textSecondary: '#A8A8B3',
    backgroundBox: '#FEFEFE',
  },
};